import {
  RiDownloadCloud2Line,
  RiFolder3Line,
  RiLineChartLine,
  RiMenuLine,
  RiTrophyLine,
} from "react-icons/ri";
import { Link } from "react-router-dom";
import { useOnboard } from "../../../hooks/OnboardContext";
import { i18n } from "../../../localization/i18n";
import { RouteButton } from "../styles";

interface MenuListProps {
  extendedMode: boolean;
}

export const EmployeeMenuList = ({ extendedMode }: MenuListProps) => {
  const { licensee, planHasExpired } = useOnboard();

  return (
    <>
      <Link to={"/employee/dashboard"}>
        {" "}
        {/* Go to Dashboard */} {/* 6 because of 12px margin */}
        <RouteButton extendedMode={extendedMode} disabled={planHasExpired || licensee?.is_blocked}>
          <RiLineChartLine size={28} />

          {extendedMode && <span>{`${i18n.t("sidebar.reports")}`}</span>}
        </RouteButton>
      </Link>

      <Link to={licensee?.is_blocked ? "/employee/dashboard" : "/employee/solutions"}>
        {" "}
        {/* Go to Solutions */}
        <RouteButton extendedMode={extendedMode} disabled={planHasExpired || licensee?.is_blocked}>
          <RiDownloadCloud2Line size={28} />
          {extendedMode && <span>{`${i18n.t("sidebar.solutions")}`}</span>}
        </RouteButton>
      </Link>

      <Link to={licensee?.is_blocked ? "/employee/dashboard" : "/employee/orders"}>
        {" "}
        {/* Go to Dashboard */} {/* 6 because of 12px margin */}
        <RouteButton extendedMode={extendedMode} disabled={planHasExpired || licensee?.is_blocked}>
          <RiMenuLine size={28} />

          {extendedMode && <span>{`${i18n.t("sidebar.requests")}`}</span>}
        </RouteButton>
      </Link>
      {licensee?.situation === "active" && (
        <>
          <a
            href="https://drive.google.com/drive/folders/12ouIWR70G6D1YOIiq4e8nstEZZ_tirVf?usp=sharing"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            {/* Go to Drive Folder */}
            <RouteButton
              extendedMode={extendedMode}
              disabled={planHasExpired || licensee?.is_blocked}
            >
              <RiFolder3Line size={26} />
              {extendedMode && <span>{`${i18n.t("sidebar.files")}`}</span>}
            </RouteButton>
          </a>

          <Link to="/success">
            {" "}
            {/* Go to Success */}
            <RouteButton extendedMode={extendedMode} disabled={planHasExpired || licensee?.is_blocked}>
              <RiTrophyLine size={28} />
              {extendedMode && <span>{`${i18n.t("sidebar.success")}`}</span>}
            </RouteButton>
          </Link>
        </>
      )}
    </>
  );
};
